
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootReducers } from './../redux/reducers/index.ts';


const ProtectedAdminRoute = ({ children }) => {
  const auth = useSelector((state: RootReducers) => state.AuthReducer);
  
  if (auth.result?.data && auth.result.data.person_type_id >= '20') {
    return children;
  }

  return <Navigate to="/HomePage" replace />;
};

export default ProtectedAdminRoute;